<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="12.506" height="12.261" viewBox="0 0 12.506 12.261">
		<g id="Group_30567" data-name="Group 30567" transform="translate(-1654 -248)">
			<g id="Group_30557" data-name="Group 30557" transform="translate(1654 248)">
				<g id="Group_30554" data-name="Group 30554">
					<g id="Group_30563" data-name="Group 30563">
						<line
							id="Line_889"
							data-name="Line 889"
							x2="11.306"
							transform="translate(0.6 0.6)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<line
							id="Line_890"
							data-name="Line 890"
							x2="11.306"
							transform="translate(0.6 6.131)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
					</g>
				</g>
				<line
					id="Line_891"
					data-name="Line 891"
					x2="7.34"
					transform="translate(2.583 3.365)"
					fill="none"
					stroke="#5a677d"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.2"
				/>
				<line
					id="Line_892"
					data-name="Line 892"
					x2="7.34"
					transform="translate(2.583 8.895)"
					fill="none"
					stroke="#5a677d"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.2"
				/>
				<g id="Group_30556" data-name="Group 30556">
					<g id="Group_30559" data-name="Group 30559">
						<line
							id="Line_893"
							data-name="Line 893"
							x2="11.306"
							transform="translate(0.6 11.661)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TextAlignCenterSvg',
};
</script>

<style scoped lang="scss"></style>
